import { useContext } from "react";
import { AuthContext } from "~/src/auth/contexts";

export default () => {
  const { auth } = useContext(AuthContext);
  return auth;
};
